module.exports = __webpack_public_path__ + "img/pay.1715f5e3.jpg";